import { Box } from '@mui/material';
import {
  useApplyVideoObjectFit,
  useAudioVideo,
  useLocalVideo,
} from 'amazon-chime-sdk-component-library-react';
import { BaseSdkProps } from 'amazon-chime-sdk-component-library-react/lib/components/sdk/Base';
import React, { HTMLAttributes, useEffect, useRef } from 'react';

import DefaultUserIcon from './defaultUserIcon';
import Nameplate from './nameplate';
import VideoTile from './videoTile';

interface Props
  extends Omit<HTMLAttributes<HTMLDivElement>, 'css'>,
  BaseSdkProps {
  /** The name to show on the video's nameplate */
  name?: string;
  attendeeID: string;
}

export const LocalUserVideo: React.FC<React.PropsWithChildren<Props>> = ({
  name,
  className,
  attendeeID,
  ...rest
}) => {
  const audioVideo = useAudioVideo();
  const videoEl = useRef<HTMLVideoElement>(null);
  const { tileId, isVideoEnabled } = useLocalVideo();

  useApplyVideoObjectFit(videoEl);

  useEffect(() => {
    if (!audioVideo || !tileId || !videoEl.current || !isVideoEnabled) {
      return;
    }

    audioVideo.bindVideoElement(tileId, videoEl.current);

    return () => {
      const tile = audioVideo.getVideoTile(tileId);
      if (tile) {
        audioVideo.unbindVideoElement(tileId);
      }
    };
  }, [audioVideo, tileId, isVideoEnabled]);

  return (
    <Box
      sx={{
        position: 'relative',
        background: '#333',
        width: '100%',
        height: '100%',
      }}
    >
      <VideoTile
        ref={videoEl}
        className={className ?? ''}
        hidden={!isVideoEnabled}
        {...rest}
      />
      <DefaultUserIcon hidden={isVideoEnabled} name={name} />
      {name && <Nameplate name={name} attendeeID={attendeeID} />}
    </Box>
  );
};

export default LocalUserVideo;
